/**
 * Builds the axios config for requests to the ColdFusion backend.
 * Always sends the API gateway key; adds Basic Auth when staging auth is enabled.
 * Pass `extra` for per-call options (e.g. { responseType: 'blob' }).
 */
export const buildAxiosConfig = (extra = {}) => {
    const headers = {
        'X-API-Key': process.env.REACT_APP_API_GATE_KEY,
        ...(extra.headers || {})
    };

    if (process.env.REACT_APP_ENABLE_STAGING_AUTH === 'true') {
        const username = process.env.REACT_APP_API_USERNAME || '';
        const password = process.env.REACT_APP_API_PASSWORD || '';
        const credentials = btoa(`${username}:${password}`);
        headers['Authorization'] = `Basic ${credentials}`;
    }

    return { ...extra, headers };
};
